export const CHANGE_WITH_MEMBERSHIP_BOARD_RECURSIVE = 'CHANGE_WITH_MEMBERSHIP_BOARD_RECURSIVE'

export const changeWithMembershipBoardRecursive = payload => ({
  type: CHANGE_WITH_MEMBERSHIP_BOARD_RECURSIVE,
  payload,
})
